<template>
  <!-- OVO TREBA? TRGA POPIS FOLDERA NA UPLOADU DOKUMENTA U POŠTU -->
  <!-- <div v-scroll-reveal.reset="{ delay: 100 }"> -->
  <div>
    <!-- <div :style="indent" v-if="item != undefined" @click="toggleChildren">
      {{ item.name }}
    </div> -->
    <div :class="['spis-megawrapper', item.children.find((it)=>it.item.folder != undefined) ? 'drop-icon-handling' : '']" v-if="item != undefined" @click.stop="setActive">
      <div
        v-if="item.item.folder != undefined"
        class="inside-folder-tree-folder"
        :class="depth > 0 ? 'inside-folder-folder' : ''"
        :style="indent"
      >
        <div class="drop-icon-svg" @click.stop="toggleChildren()" >
          <svg v-if="showChildren" xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.28033 0.21967C9.57322 0.512563 9.57322 0.987437 9.28033 1.28033L5.28033 5.28033C4.98744 5.57322 4.51256 5.57322 4.21967 5.28033L0.21967 1.28033C-0.0732231 0.987437 -0.0732231 0.512563 0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L4.75 3.68934L8.21967 0.21967C8.51256 -0.0732233 8.98744 -0.0732233 9.28033 0.21967Z" fill="#59596E"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L5.28033 4.21967C5.57322 4.51256 5.57322 4.98744 5.28033 5.28033L1.28033 9.28033C0.987437 9.57322 0.512563 9.57322 0.21967 9.28033C-0.0732233 8.98744 -0.0732233 8.51256 0.21967 8.21967L3.68934 4.75L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z" fill="#303779"/>
          </svg>
        </div>
        <div class="inside-folder-left" >
          <div class="inside-folder-icon spis-folder">
            <img class="doc-icon" src="@/assets/img/folder_icon_gray.svg" />
          </div>
          <div class="inside-folder-txts">
            <div class="inside-folder-title">{{ item.item.name }}</div>
            <div class="detalji-spisa-tiny">
              <span class="broj-dokumenata"
                >{{ item.item.childCount }} dokumenta</span
              ><span class="tezina">{{ item.item.size / 1000000 }}mb</span>
            </div>
          </div>
        </div>
        <div class="inside-folder-active">
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.51345 1.60419C2.35387 1.60419 1.60449 2.39848 1.60449 3.62819V7.37185C1.60449 8.60156 2.35387 9.39585 3.51345 9.39585H7.48628C8.64633 9.39585 9.39616 8.60156 9.39616 7.37185V3.62819C9.39616 2.39848 8.64632 1.60419 7.48674 1.60419H3.51345ZM7.48628 10.0834H3.51345C1.96016 10.0834 0.916992 8.99344 0.916992 7.37185V3.62819C0.916992 2.0066 1.96016 0.916687 3.51345 0.916687H7.48674C9.04003 0.916687 10.0837 2.0066 10.0837 3.62819V7.37185C10.0837 8.99344 9.04003 10.0834 7.48628 10.0834V10.0834Z" fill="#303778"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.95613 6.93142C4.86859 6.93142 4.78013 6.89796 4.71322 6.83059L3.62513 5.74296C3.49084 5.60867 3.49084 5.39142 3.62513 5.25713C3.75942 5.12284 3.97667 5.12284 4.11097 5.25713L4.95613 6.10138L6.88847 4.16951C7.02276 4.03521 7.24001 4.03521 7.3743 4.16951C7.50859 4.3038 7.50859 4.52105 7.3743 4.65534L5.19905 6.83059C5.13213 6.89796 5.04413 6.93142 4.95613 6.93142" fill="#303778"/>
          </svg>
          <span>odabrano</span>
        </div>
        <div class="inside-folder-right">
          <div class="ordinal">2</div>
          <div class="date">{{formatDate(item.item.createdDateTime)}}</div>
          <div class="view">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="14"
              viewBox="0 0 24 14"
            >
              <g>
                <g>
                  <path
                    fill="#a2a4b0"
                    d="M23.885 6.475a.942.942 0 0 1 0 1.125c-3.044 4.04-7.17 6.528-11.72 6.528-4.55 0-8.675-2.488-11.72-6.533a.942.942 0 0 1 0-1.125C3.49 2.43 7.615-.059 12.165-.059c4.55 0 8.676 2.488 11.72 6.534zm-6.722.886A5.01 5.01 0 0 0 11.84 2.04c-2.494.156-4.516 2.176-4.671 4.669a5.01 5.01 0 0 0 5.324 5.32c2.489-.16 4.51-2.18 4.671-4.668zm-4.822 2.361A2.692 2.692 0 0 1 9.476 6.86a2.708 2.708 0 0 1 2.519-2.517 2.692 2.692 0 0 1 2.864 2.862 2.708 2.708 0 0 1-2.518 2.517z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="add-folder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="22"
              viewBox="0 0 28 22"
            >
              <g>
                <g>
                  <path
                    fill="#b1b3bd"
                    d="M27.721 6.067v13.471A2.46 2.46 0 0 1 25.286 22H2.555A2.46 2.46 0 0 1 .12 19.538V3.291A2.46 2.46 0 0 1 2.555.827h9.02a.338.338 0 0 1 .27.122l2.232 2.657h11.209a2.46 2.46 0 0 1 2.435 2.461zm-8.74 6.633a.979.979 0 0 0-.978-.978h-3.105V8.616a.979.979 0 0 0-1.955 0v3.106H9.838a.979.979 0 0 0 0 1.956h3.105v3.106c0 .539.438.978.977.978.54 0 .978-.44.978-.978v-3.106h3.105c.539 0 .977-.439.977-.978z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="inside-folder-more">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="5"
              height="20"
              viewBox="0 0 5 20"
            >
              <g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 0a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 7.823a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 15.124a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div v-show="showChildren">
      <tree-folders
         v-for="(node, key) in item.children"
        :key="key"
        :item="node"
        :depth="depth + 1"
        @node-click="handleClick"
      >
      </tree-folders>
    </div>
  </div>
</template>
<script>
import share from "@/apiCallers/sharepoint";
import moment from "moment";
import $ from "jquery";
export default {
  props: ["item", "nodes", "depth", "accessToken","smjer"],
  name: "tree-folders",
  watch: {
    nodes: function (newVal, oldVal) {
      // watch it
      // console.log("Prop changed: ", newVal, " | was: ", oldVal);
      var i = 0;
      if (newVal != undefined) {
        newVal.forEach((el) => {
          this.loop_docs.push(undefined);
          this.loop_docs[i] = this.getfoldersById(el);
          i++;
        });
      }
    },
  },
  data() {
    return { showChildren: true, trigg: false, loop_docs: [] };
  },

  computed: {
    indent() {
      var sirina = 100 - this.depth * 5 + "%";
      return { width: sirina };
    },
  },
  methods: {
    setActive(e){
      this.handleClick(this.item.item);
      $('.spis-megawrapper').removeClass('active');
      $(e.target).closest('.spis-megawrapper').toggleClass('active');
    },
    formatDate(datum) {
      return moment(datum.toString()).format("L");
    },
    toggleChildren() {    
      this.showChildren = !this.showChildren;
    },
    handleClick(node) {
      this.$emit("node-click", node);
    },
  },

  // mounted() {
  //   $(".inside-folder").click(function () {
  //     $(".eye_clicked").removeClass("eye_clicked");
  //     $(this).addClass("eye_clicked");
  //   });
  // },
  // destroyed() {
  //   $(".inside-folder").off();
  // },
};
</script>